import { Cardholder, HeartStraight, House, Tray } from '@phosphor-icons/react';
import { Badge } from '@mui/material';
import { useSelector } from 'react-redux';

import { MainKeys } from 'theSource/app/routes';
import { selectFeedMessageCount } from 'theSource/features/Inbox/services';

function notificationsLabel(count: number) {
  if (count === 0) {
    return;
  }
  if (count > 999) {
    return 'more than 999 notifications';
  }
  return `${count} notifications`;
}

const InboxIcon: React.ElementType = () => {
  const count = useSelector(selectFeedMessageCount);
  return (
    <>
      <Badge
        badgeContent={count}
        color="error"
        invisible={count === 0}
        max={999}
        aria-label={notificationsLabel(count)}
      >
        <Tray size={26} weight="duotone" />
      </Badge>
    </>
  );
};

export const BOTTOM_NAVIGATION_ICONS: Record<MainKeys, JSX.Element> = {
  home: <House size={26} weight="duotone" />,
  benefits: <HeartStraight size={26} weight="duotone" />,
  idCards: <Cardholder size={26} weight="duotone" />,
  inbox: <InboxIcon />,
};
